import Dropdown from '../Dropdown/Dropdown'
import Tooltip from '../Tooltip/Tooltip'
import classes from './ItemMenu.module.scss'
import type { options as OptionsType } from '../types'
import type { ReactNode } from 'react'

export interface Props {
  preferredPosition?: 'right-auto' | 'right'
  onSelect: (value: string) => void
  tooltip?: string
  options: OptionsType
  customButton: ReactNode
  isDisabled?: boolean
}

const ItemMenuWithText = ({
  preferredPosition = 'right',
  onSelect,
  options,
  tooltip = 'Actions',
  customButton,
  isDisabled = false
}: Props) => {
  const renderButton = (getToggleButtonProps: () => {'aria-label': string}) => {
    const toggleButtonProps = getToggleButtonProps()

    const isDropdownOpen = toggleButtonProps['aria-label'] === 'close menu'

    const renderButton = (
      <div className={classes.IconWrapper}>
        {customButton}
      </div>
    )

    const button =
      <button
        className={classes.CustomButton}
        disabled={isDisabled}
        type='button'
        {...toggleButtonProps}
        aria-label={
          isDropdownOpen
            ? 'close actions menu'
            : 'open actions menu'
        }
      >
        {renderButton}
      </button>

    // Prevent the tooltip from colliding with the open menu
    return isDropdownOpen
      ? button
      : (
        <Tooltip label={tooltip}>
          {button}
        </Tooltip>
      )
  }

  return (
    <Dropdown
      onSelect={onSelect}
      options={options}
      preferedPosition={preferredPosition}
      renderButton={renderButton}
    />
  )
}

export default ItemMenuWithText
